import * as React from 'react';

import { ESuburbanUtility } from '../../../../../../../json_query';
import { getArrayChange } from '../../../../../../../utils/arrayChange';
import { DropdownField } from '../../../components/dropdownField';

export interface ISuburbanUtilitiesProps {
  value: ESuburbanUtility[];
  onChange(utility: ESuburbanUtility, value: boolean | undefined): void;
}

interface ISuburbanUtility {
  label: string;
  value: ESuburbanUtility;
}

const VALUES: ISuburbanUtility[] = [
  { label: 'Электричество', value: ESuburbanUtility.Electricity },
  { label: 'Газ', value: ESuburbanUtility.Gas },
  { label: 'Канализация', value: ESuburbanUtility.Drainage },
  { label: 'Водоснабжение', value: ESuburbanUtility.Water },
];

export const SuburbanUtilities: React.StatelessComponent<ISuburbanUtilitiesProps> = ({ value, onChange }) => (
  <DropdownField
    multiple
    placeholder="Неважно"
    value={value.concat()}
    onValueChange={(utilities: ESuburbanUtility[]) => onChange(...getArrayChange(value, utilities))}
    values={VALUES}
  />
);
